<template>
    <div class="p-3 row justify-content-center">
        <el-card class="col-12" :header="place.id ? place.name:'Procurando local'">
            <el-skeleton :loading="loading" animated :rows="12">
                <template #default>
                    <el-form :disabled="saving" v-if="place" :model="place" label-position="top" :rules="rules" ref="formRef">
                        <el-row :gutter="30">
                            <el-col :sm="24" :md="12" :lg="10">
                                <el-form-item label="Nome" prop="name">
                                    <el-input name="name" v-model="place.name" />
                                </el-form-item>
                                <el-form-item label="Categoria" prop="category_id">
                                    <el-select v-model="place.category_id">
                                        <el-option v-for="c in categories" :label="c.name" :value="c.id" :key="c.id">
                                            {{ c.name }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Descricao do local" prop="description">
                                    <el-input type="textarea" name="description" v-model="place.description" />
                                </el-form-item>
                                <el-form-item label="Cadastrado por">
                                    {{ place.user?.name }}
                                </el-form-item>
                                <el-form-item label="Adicionado em" prop="created_at">
                                    {{ new Date(place.created_at).toLocaleString() }}
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :md="12" :lg="14">
                                <el-form-item label="Local" prop="area.name" v-if="place.area">
                                    <!-- {{place.area}} -->
                                    <el-input name="area" v-model="place.area.name" />
                                </el-form-item>
                                <div style="height: 400px; width: 100%" class="position-relative">
                                    <el-button plain class="position-absolute end-0" style="z-index: 1024;" :loading="locating || loading" size="large" type="success" @click.prevent="locate">
                                        Localizar-me
                                    </el-button>
                                    <l-map @contextmenu="onMapClick" ref="map" v-if="place.area" :zoom="16" :center="[place.area.lat, place.area.long]">
                                        <l-tile-layer
                                            url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"
                                            layer-type="base"
                                            name="OpenStreetMap"
                                        ></l-tile-layer>

                                        <l-marker v-if="place.area" :lat-lng="[place.area.lat, place.area.long]">
                                            <l-tooltip>{{ place.name }}</l-tooltip>
                                        </l-marker>
                                    </l-map>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row justify="end" class="py-4">
                        <el-col class="col-auto">
                            <el-button type="primary" @click="submit(formRef)" plain :loading="saving">
                                Salvar alterações
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-col>
                        <h6>Galeria</h6>
                        <el-divider />
                    </el-col>
                    <el-row :gutter="20" v-if="typeof place.images[0] == 'object'">
                        <el-col :sm="6" :md="4" v-for="img in place.images" :key="img.id">
                            <video v-if="isVideoFile(img.url)" controls class="col-12">
                                <source :src="`${Api.publicUrl}images/ads/${img.url}`" />
                            </video>
                            <el-image v-else alt="" :src="`${Api.publicUrl}images/ads/${img.url}`" class="col-12" />
                        </el-col>
                    </el-row>
                </template>
            </el-skeleton>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import Api from "@/services/api";
    import { Ad, Category } from "@/services/types";
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
    import { onBeforeMount, reactive, ref } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip, } from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'

    const router = useRouter()
    const loading = ref<boolean>(true)
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const place = reactive<Ad>({
        name: '',
        description: ''
    })
    const locating = ref<boolean>(false)
    
    const route = useRoute()
    const id = route.params.id

    const rules = reactive<FormRules<Ad>>({
        name: [{required: true, message: 'Informe seu nome', min: 2}],
        description: [{required: true, message: 'Descreva o local', min: 2}],
        category_id: [{required: true, message: 'Precisa selecionar uma categoria'}],
        "area.name": [{required: true, message: 'Forneça a localizacao'}],
    })

    const categories = reactive<Array<Category>>([])

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (place.area) {
                place.area.lat = position.coords.latitude
                place.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }
    
    const getPlace = async (adId: number) => {
        const res = await Api.get('admin/ads/' + adId)
        console.log(res.data)
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ao prourar este local', {
                type: "error"                
            }).then(() => {
                router.push('/places')
            })
        } else {
            const data = res.data.ad
            place.area = data.area
            place.area_id = data.area_id
            place.category = data.category
            place.category_id = data.category_id
            place.description = data.description
            place.images = data.images
            place.name = data.name
            place.user = data.user
            place.user_id = data.user_id
            place.id = data.id
            place.created_at = data.created_at
            console.log(place.area)
        }
    }

    onBeforeMount(async () => {
        loading.value = true
        
        const res = await Api.get('admin/categories')
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message)
        } else {
            const data = res.data.categories
            categories.splice(0)
            data.forEach((element: Category) => {
                categories.push(element)
            });
        }

        await getPlace(Number(id))
        loading.value = false
    })

    const isVideoFile = (filename: string): boolean => {
        const videoExtensions = [".mp4", ".avi", ".mpeg", ".quicktime", ".webm"];
        return videoExtensions.some(ext => filename.endsWith(ext));
    }

    const onMapClick = (event: LeafletMouseEvent) => {
        const { lat, lng } = event.latlng
        if (place.area) {
            place.area.lat = lat
            place.area.long = lng
        } else {
            place.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(place.area);
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!place.area?.lat || !place.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                saving.value = true
                const data = new FormData()
                data.append('name', place.name)
                data.append('category_id', `${place.category_id}`)
                data.append('description', place.description)
                
                // Area
                if (place.area) {
                    data.append('area[name]', place.area.name)
                    data.append('area[lat]', place.area.lat.toString())
                    data.append('area[long]', place.area.long.toString())
                }
                const res = await Api.put('admin/ads/' + id, place, data)
                console.log(res.data)

                if (res.status == 200) {
                    ElMessage.success({message: 'Dados atualizados com sucesso'})
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        const erros = res.data.errors
                        console.log(formRef.value)
                        formRef.value?.fields.forEach((val) => {
                            console.log(val)
                            Object.keys(erros).forEach(field => {
                                if (val.prop == field) {
                                    val.validateState = "error"
                                    ElMessage({
                                        type: "error",
                                        message: res.data.errors[field][0]
                                    })
                                }
                            })
                        })
                    }
                } else {
                    ElMessage.error({message: "Ocorreu um erro " + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
